import { use as i18nextUse } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { icuPostProcessor } from './icuPostProcessor';
import en from './locales/.generated/en.json';
import ja from './locales/.generated/ja.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'ja', label: '日本語' },
  { code: 'en', label: 'English' },
] as const;

export const resources = {
  en: { translation: en },
  ja: { translation: ja },
};

i18nextUse(initReactI18next)
  .use(LanguageDetector)
  .use(icuPostProcessor)
  .init({
    postProcess: 'icu',
    defaultNS: 'translation',
    debug: process.env.NODE_ENV !== 'production',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    load: 'languageOnly',
    fallbackLng: 'ja',
    resources,
    interpolation: { escapeValue: false },
    detection: {
      order: ['cookie', 'navigator'],
      caches: ['cookie'],
      lookupCookie: 'i18next',
      convertDetectedLanguage: (lng: string) => (lng.split('-')[0] === 'ja' ? 'ja' : 'en'),
      cookieOptions: {
        path: '/',
        sameSite: 'lax',
        secure: location.protocol === 'https:',
      },
    },
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: true,
    },
  });
